import { Dialog, DialogHeader, Divider, Label } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import * as React from 'react';
import './DetailsReadOnly.scss';

/*
  This component is intended to be used to create dialog prompts that have key:value rows that are
  grouped into sections. An optional title will provide a header with title.
*/
interface IDetailsReadOnlyRow {
  title: string;
  detail: string;
}

interface IDetailsReadOnlySection {
  rows: IDetailsReadOnlyRow[];
}

export interface IDetailsReadOnlyProps {
  title?: string;
  data: IDetailsReadOnlySection[];
  isOpen: boolean;
  className?: string | object;
  sectionClassName?: string | object;
  onClose?: () => void;
  layer?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
}

const DetailsReadOnly: React.FunctionComponent<IDetailsReadOnlyProps> = (props) => {
  const sections = props.data.map((section, sectionKey) => {
    const rows = section.rows.map((row, rowKey) => {
      return (
        <React.Fragment key={rowKey}>
          <Label className="detail-title">{row.title}</Label>
          <Label className="detail">{row.detail}</Label>
        </React.Fragment>
      );
    });

    const sectionClasses = classNames(
      {
        'bottom-section': sectionKey === props.data.length - 1 ? true : false,
        'section': true,
      },
      props.sectionClassName
    );

    return (
      <div className={sectionClasses} key={sectionKey}>
        {rows}
      </div>
    );
  });
  const dividedSections = sections.map((section, index) => {
    return (
      <React.Fragment key={index}>
        {index !== 0 ? <Divider /> : null}
        {section}
      </React.Fragment>
    );
  });

  const header = props.title ? (
    <DialogHeader divider={true}>
      <h1>{props.title}</h1>
    </DialogHeader>
  ) : null;

  return (
    <Dialog isOpen={props.isOpen} className={props.className} onClose={props.onClose} layer={props.layer}>
      {header}
      {dividedSections}
    </Dialog>
  );
};

export default DetailsReadOnly;
